import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "./BasePanelPage";
import {
    LoginWithEmailCode,
    LoginWithEmailCodeStyle
} from "../../../website/unauthenticated/slides/LoginWithEmailCodeForm";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {Router} from "../../../../stem-core/src/ui/Router";


class EmailCodeConfirmationComponentStyle extends LoginWithEmailCodeStyle {
    @styleRuleInherit
    component = {
        " input": {
            borderColor: this.themeProps.MERCHANT_INPUT_BORDER_COLOR,
            background: this.themeProps.MERCHANT_INPUT_BACKGROUND,
        },
        " input:focus": {
            borderColor: this.themeProps.MERCHANT_INPUT_BORDER_ACTIVE_COLOR,
        },
    };

    @styleRule
    title = this.themeProps.PANEL_TITLE;
}

@registerStyle(EmailCodeConfirmationComponentStyle)
class EmailCodeConfirmationComponent extends LoginWithEmailCode {
    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.authEmailConfirmationTitle}</div>,
            super.getBeforeInput(),
        ];
    }
}

export class EmailCodeConfirmationPanel extends BasePanelPage {
    render() {
        return <EmailCodeConfirmationComponent onWrongEmailButtonClick={() => Router.back()}/>;
    }
}
